import * as React from "react";

/**
 * When true, datasheet result fields are not editable (e.g. IDS/PDS lock held by another user,
 * or lock not yet acquired). Same tree is used for full tab and pedigree split (formatOnly) view.
 */
export const DatasheetResultInteractionLockedContext = React.createContext(false);

export const useDatasheetResultInteractionLocked = (): boolean =>
  React.useContext(DatasheetResultInteractionLockedContext);

/**
 * Combines per-field format permission with global interaction lock so every field can call one hook.
 */
export function useDatasheetResultFieldEditable(baseEditable: boolean): boolean {
  const interactionLocked = useDatasheetResultInteractionLocked();
  return Boolean(baseEditable) && !interactionLocked;
}
